import MultiSelectIdentificationTokenType from './MultiSelectIdentificationTokenType';

export default MultiSelectIdentificationTokenType;
